import { useState, useEffect, useRef } from "react";
import "./SectionedFeature.css";
import parse from "html-react-parser";
import { APP_COLORS } from "../../constants/styles";

import AnimatedText from "./AnimatedText";

function SectionedFeature({ contents, colors: colorObj }) {
    const [activeIndex, setActiveIndex] = useState(0);

    const [prevIndex, setPrevIndex] = useState(activeIndex);
    const [isAnimating, setIsAnimating] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        setIsAnimating(true);

        timeoutRef.current = setTimeout(() => {
            setPrevIndex(activeIndex);
            setIsAnimating(false);
        }, 600);

        return () => clearTimeout(timeoutRef.current);
    }, [activeIndex, prevIndex]);

    return (
        <>
            <section
                className="pt-[40px] pb-[40px] md:pt-[80px] md:pb-[80px] px-4 flex flex-col items-center"
                style={APP_COLORS(colorObj)}
            >
                <div>
                    <div className=" md:flex relative w-full flex max-md:flex-col max-md:items-center">
                        <ul className="wrapper_content relative max-w-[350px] mb-[40px] md:max-w-[656px] md:mr-[36px] md:mb-[0]">
                            {contents.map(({ heading, body, id }, idx) => (
                                <li
                                    key={id}
                                    className={`slider-nav__item ${
                                        idx === activeIndex ? "active" : ""
                                    }`}
                                    onClick={() => setActiveIndex(idx)}
                                >
                                    <h3
                                        className={`text-[32] font-semibold  md:text-[40px] mb-[16px] 
                                    ${
                                        idx === activeIndex
                                            ? "text-[--accent_color1]"
                                            : "text-[--accent_color2]"
                                    }`}
                                    >
                                        {heading}
                                    </h3>

                                    <AnimatedText isActive={idx === activeIndex}>
                                        <div className="text-[16px] leading-[24px] md:mt-[16px] md:text-[20px] font-normal md:leading-[30px] md:text-[var(--accent-color1)] overflow-hidden">
                                            {parse(body)}
                                        </div>
                                    </AnimatedText>
                                </li>
                            ))}
                        </ul>

                        <div className="max-md:flex max-md:justify-center">
                            <div className="relative min-w-[350px] h-[350px] md:w-[500px] md:h-[400px] overflow-hidden rounded-[15px] responsive-image">
                                <img
                                    src={contents[prevIndex].content_image.src}
                                    alt={contents[prevIndex].content_image.alt}
                                    className={`fade-transition ${isAnimating ?? "fade-visible"}`}
                                />
                                <img
                                    src={contents[activeIndex].content_image.src}
                                    alt={contents[activeIndex].content_image.alt}
                                    className={`fade-transition ${
                                        isAnimating ? "fade-visible" : "fade-hidden"
                                    }`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default SectionedFeature;
